const ROOT = "table-component";
const INSERT_TABLE_BUTTON = "insert-table-button";
const INSERT_TABLE_MODAL = "insert-table-modal";
const INSERT_TABLE_MODAL_ROWS_INPUT = "insert-table-modal-row-count";
const INSERT_TABLE_MODAL_COLUMNS_INPUT = "insert-table-modal-column-count";
const INSERT_TABLE_MODAL_ERROR_MESSAGE = "insert-table-modal-error-message";
const INSERT_TABLE_MODAL_FOOTER_ACTIONS = "insert-table-modal-footer-actions";
const INSERT_TABLE_MODAL_ADD_BUTTON = "insert-table-modal-add-button";
const INSERT_TABLE_MODAL_GRID_SELECTOR = "insert-table-modal-grid-selector";
const TABLE_PLUGIN_CELL = "table-plugin-cell";
const PLUGIN_TOOLBAR_VERTICAL_ALIGNMENT_BUTTON = "plugin-toolbar-vertical-alignment-button";
const PLUGIN_TOOLBAR_BACKGROUND_COLOR_BUTTON = "plugin-toolbar-background-color-button";
const PLUGIN_TOOLBAR_BORDER_COLOR_BUTTON = "plugin-toolbar-border-color-button";
const PLUGIN_TOOLBAR_BORDER_WIDTH_BUTTON = "plugin-toolbar-border-width-button";
const PLUGIN_TOOLBAR_CONTEXT_MENU_BUTTON = "plugin-toolbar-context-menu-button";
const PLUGIN_TOOLBAR_ROW_HEADER_BUTTON = "plugin-toolbar-row-header-button";
const PLUGIN_TOOLBAR_COLUMN_HEADER_BUTTON = "plugin-toolbar-column-header-button";
const PLUGIN_TOOLBAR_MERGE_CELLS_BUTTON = "plugin-toolbar-merge-cells-button";
const PLUGIN_TOOLBAR_SPLIT_CELL_BUTTON = "plugin-toolbar-split-cell-button";
const PLUGIN_TOOLBAR_TEXT_ALIGNMENT_BUTTON = "plugin-toolbar-text-alignment-button";
const PLUGIN_TOOLBAR_ADD_ROW_COL_BUTTON = "plugin-toolbar-add-row-col-button";
const PLUGIN_TOOLBAR_SPACING_BUTTON = "plugin-toolbar-spacing-button";
const PLUGIN_TOOLBAR_MOVE_COLUMN_LEFT_BUTTON = "plugin-toolbar-move-column-left-button";
const PLUGIN_TOOLBAR_MOVE_COLUMN_RIGHT_BUTTON = "plugin-toolbar-move-column-right-button";
const PLUGIN_TOOLBAR_MOVE_ROW_UP_BUTTON = "plugin-toolbar-move-row-up-button";
const PLUGIN_TOOLBAR_MOVE_ROW_DOWN_BUTTON = "plugin-toolbar-move-row-down-button";
const TABLE_BORDER_WIDTH_MODAL = "table-border-width-modal";
const TABLE_BORDER_WIDTH_SLIDER_COMPONENT = "table-border-width-slider";
const TABLE_BORDER_WIDTH_INPUT = "table-border-width-input";
const TABLE_BORDER_COLOR_INPUT = "table-border-color-input";
const TABLE_BORDER_COLOR_PICKER = "table-border-color-picker";
const TABLE_CELL_SPACING_INPUT = "table-cell-spacing-input";
const TABLE_CELL_PADDING_INPUT = "table-cell-padding-input";
const TABLE_CELL_PADDING_TOGGLE_INDIVIDUAL = "table-cell-padding-toggle-individual";
const TABLE_CELL_PADDING_TOP = "table-cell-padding-top";
const TABLE_CELL_PADDING_RIGHT = "table-cell-padding-right";
const TABLE_CELL_PADDING_BOTTOM = "table-cell-padding-bottom";
const TABLE_CELL_PADDING_LEFT = "table-cell-padding-left";
const TABLE_CELL_PADDING_HORIZONTAL = "table-cell-padding-horizontal";
const TABLE_CELL_PADDING_VERTICAL = "table-cell-padding-vertical";
const TABLE_BORDER_MODAL = "table-border-modal";
const TABLE_COLUMN_HANDLE = "column-handle";
const TABLE_ROW_HANDLE = "row-handle";
const TABLE_ADD_ROW_BUTTON = "addRow";
const TABLE_ADD_COL_BUTTON = "addCol";
const TABLE_SELECTOR = "table-selector";
const DATA_CELL_SELECTED = "data-cell-selected";
export {
  DATA_CELL_SELECTED,
  INSERT_TABLE_BUTTON,
  INSERT_TABLE_MODAL,
  INSERT_TABLE_MODAL_ADD_BUTTON,
  INSERT_TABLE_MODAL_COLUMNS_INPUT,
  INSERT_TABLE_MODAL_ERROR_MESSAGE,
  INSERT_TABLE_MODAL_FOOTER_ACTIONS,
  INSERT_TABLE_MODAL_GRID_SELECTOR,
  INSERT_TABLE_MODAL_ROWS_INPUT,
  PLUGIN_TOOLBAR_ADD_ROW_COL_BUTTON,
  PLUGIN_TOOLBAR_BACKGROUND_COLOR_BUTTON,
  PLUGIN_TOOLBAR_BORDER_COLOR_BUTTON,
  PLUGIN_TOOLBAR_BORDER_WIDTH_BUTTON,
  PLUGIN_TOOLBAR_COLUMN_HEADER_BUTTON,
  PLUGIN_TOOLBAR_CONTEXT_MENU_BUTTON,
  PLUGIN_TOOLBAR_MERGE_CELLS_BUTTON,
  PLUGIN_TOOLBAR_MOVE_COLUMN_LEFT_BUTTON,
  PLUGIN_TOOLBAR_MOVE_COLUMN_RIGHT_BUTTON,
  PLUGIN_TOOLBAR_MOVE_ROW_DOWN_BUTTON,
  PLUGIN_TOOLBAR_MOVE_ROW_UP_BUTTON,
  PLUGIN_TOOLBAR_ROW_HEADER_BUTTON,
  PLUGIN_TOOLBAR_SPACING_BUTTON,
  PLUGIN_TOOLBAR_SPLIT_CELL_BUTTON,
  PLUGIN_TOOLBAR_TEXT_ALIGNMENT_BUTTON,
  PLUGIN_TOOLBAR_VERTICAL_ALIGNMENT_BUTTON,
  ROOT,
  TABLE_ADD_COL_BUTTON,
  TABLE_ADD_ROW_BUTTON,
  TABLE_BORDER_COLOR_INPUT,
  TABLE_BORDER_COLOR_PICKER,
  TABLE_BORDER_MODAL,
  TABLE_BORDER_WIDTH_INPUT,
  TABLE_BORDER_WIDTH_MODAL,
  TABLE_BORDER_WIDTH_SLIDER_COMPONENT,
  TABLE_CELL_PADDING_BOTTOM,
  TABLE_CELL_PADDING_HORIZONTAL,
  TABLE_CELL_PADDING_INPUT,
  TABLE_CELL_PADDING_LEFT,
  TABLE_CELL_PADDING_RIGHT,
  TABLE_CELL_PADDING_TOGGLE_INDIVIDUAL,
  TABLE_CELL_PADDING_TOP,
  TABLE_CELL_PADDING_VERTICAL,
  TABLE_CELL_SPACING_INPUT,
  TABLE_COLUMN_HANDLE,
  TABLE_PLUGIN_CELL,
  TABLE_ROW_HANDLE,
  TABLE_SELECTOR
};
//# sourceMappingURL=data-hooks.js.map
